/**
 * Pre-compiled pt-BR messages for FieldErrors
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  duplicateValue: `O valor já está em uso. Use um valor único.`,
  emptyValue: `O campo não pode estar vazio.`,
  invalidFormat: `Insira um formato válido.`,
  invalidFractionalNumber: `É necessário um número inteiro.`,
  invalidFromServer: `A validação do servidor falhou. Verifique os dados inseridos.`,
  invalidNegativeNumber: `Números negativos não podem ser usados.`,
  invalidValue: `O valor fornecido é inválido.`,
  missingRequiredField: `Este campo é obrigatório. Informe um valor.`,
  resourceNotFound: `O recurso solicitado não foi encontrado.`,
  valueAboveMaximum: `O valor deve ser menor ou igual ao máximo.`,
  valueBelowMinimum: `O valor deve ser maior ou igual ao mínimo.`,
  valueBlocked: `O valor não é permitido.`,
  valueOutOfRange: `O valor deve estar dentro do intervalo aceitável.`,
  valueTooLong: `O valor é muito longo.`,
  valueTooShort: `O valor é muito curto.`,
};
